<template>
  <div>
    <a-card class="c_primary">
      <div slot="title" class="m-display-flex space-between custom">
        <span class="cmain-title"><a-icon type="project" />&nbsp;PP Inventory</span>
        <!-- <a-button
          v-if="!isMonitoringPage"
          type="primary"
          class="cbtn-create"
          icon="plus"
          @click="navigateTo('create')"
        >
          Create
        </a-button> -->
      </div>

      <a-row :gutter="[8, 16]">
        <a-col :span="24">
          <a-collapse accordion :defaultActiveKey="['1']">
            <a-collapse-panel key="1">
              <span slot="header">Filter</span>

              <a-row :gutter="[16, 16]">
                <!-- <a-col :xs="24" :sm="12" :md="12" :lg="5">
                  <div class="m-form-item-wrapper">
                    <label for="directorate">Direktorat</label>
                    <a-select placeholder="Ex: Marketing ... " class="width-full" initialValue="delivered" allowClear
                      v-model="filter.directorate">
                      <a-select-option v-for="item in data_directorate" :key="item.id" :value="item.value">{{ item.label
                      }}</a-select-option>
                    </a-select>
                  </div>
                </a-col> -->

                <a-col :xs="24" :sm="12" :md="12" :lg="5">
                  <div class="m-form-item-wrapper">
                    <label for="tanggalTransaksi">Tgl PP</label>
                    <a-range-picker v-model="dates" @change="onChangeDateFilter" />
                  </div>
                </a-col>

                <a-col :xs="24" :sm="12" :md="12" :lg="5">
                  <div class="m-form-item-wrapper">
                    <label for="tanggalTransaksi">Status</label>
                    <a-select placeholder="Ex: Approved ... " class="width-full" initialValue="delivered" allowClear
                      v-model="filter.status">
                      <a-select-option v-for="item in data_status" :key="item" :value="item">{{ item
                      }}</a-select-option>
                    </a-select>
                  </div>
                </a-col>

                <a-col :xs="24" :sm="12" :md="12" :lg="11">
                  <div class="m-form-item-wrapper">
                    <label for="tanggalTransaksi">Search</label>
                    <a-input-search v-model:value="searchTemp" placeholder="Quick search" @search="onSearch" />
                  </div>
                </a-col>
                <a-col :xs="24" :sm="12" :md="12" :lg="3">
                  <div class="m-form-item-wrapper">
                    <label style="visibility: hidden;">Action</label>
                    <a-button icon="reload" block @click="resetFilter">
                      Reset
                    </a-button>
                  </div>
                </a-col>
              </a-row>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
        <a-col :span="24">

          <a-card class="custom-card">
            <a-table size="small" rowKey="id_pp" :columns="columns" :data-source="data_table" :loading="loading.table"
              :scroll="{ x: 'max-content' }" :pagination="pagination" @change="handleTableChange" class="custom-table"
              bordered>
              <template slot="no" slot-scope="text, item, index">
                {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
              </template>
              <template slot="no_pp" slot-scope="text, item">
                <div><a @click="toManifest(item)"><b>{{ item.no_pp }}</b></a></div>
              </template>
              <template slot="tlc_create" slot-scope="text, item">
                {{
                  moment(item.create_dt).format("YYYY-MM-DD") +
                  " / " +
                  item.pembuat
                }}
              </template>
              <template slot="deskripsi" slot-scope="text, item">
                <div>
                  <b>
                    {{ item.deskripsi }}

                  </b>
                </div>
                <small>{{ item.remark ? item.remark : '-' }}</small>

              </template>
              <template slot="kurs" slot-scope="text, item">
                <CurrencyJustified v-if="item.kurs" :currencyValue="'IDR'" :valueNumber="item.kurs" />
                <div v-else style="text-align: center; width: 100%">-</div>
              </template>
              <template slot="estimated_value" slot-scope="text, item">
                <CurrencyJustified v-if="item.sub_total" :currencyValue="item.currency" :valueNumber="item.sub_total" />
                <div v-else style="text-align: center; width: 100%">-</div>
              </template>
              <template slot="status_besar" slot-scope="text, item">
                <a-tag :color="stateColor(item.status_besar)">{{
                  item.status_besar
                }}</a-tag>
              </template>
              <template slot="type_plafon" slot-scope="text, item">
                {{ item.type_plafon + " / " + item.direktorat }}
              </template>
              <template slot="status_keuangan" slot-scope="text, item">
                <a-tag :color="stateColorAp(item.status_keuangan)">{{
                  item.status_keuangan
                }}</a-tag>
              </template>
              <template slot="action" slot-scope="text, item">
                <a-button icon="eye" @click="navigateTo('manifest', item.kewajiban_id)"></a-button>
              </template>
            </a-table>
          </a-card>

        </a-col>
      </a-row>
    </a-card>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  mixins: [GlobalMethod,CurrencyFormat],
  data() {
    const columns = [
      {
        title: "No",
        align: "center",
        dataIndex: "no",
        scopedSlots: { customRender: "no" },
      },
      {
        title: "No. PP",
        key: "no_pp",
        width: 220,
        align: "center",
        scopedSlots: { customRender: "no_pp" },
      },
      {
        title: "Tgl Buat / TLC",
        key: "tlc_create",
        width: 170,
        align: "center",
        scopedSlots: { customRender: "tlc_create" },
      },
      {
        title: "Deskripsi",
        key: "deskripsi",
        width: 400,
        align: "left",
        scopedSlots: { customRender: "deskripsi" },
      },
      {
        title: "Kurs IDR",
        key: "kurs",
        dataIndex: "kurs",
        width: 100,
        align: "right",
        scopedSlots: { customRender: "kurs" },
      },
      {
        title: "Estimate Value",
        key: "estimated_value",
        width: 170,
        align: "right",
        scopedSlots: { customRender: "estimated_value" },
      },
      {
        title: "Status",
        key: "status_besar",
        align: "center",
        // fixed: "right",
        scopedSlots: { customRender: "status_besar" },
      },
      {
        title: "Plafon / Direktorat",
        key: "type_plafon",
        align: "center",
        // fixed: "right",
        scopedSlots: { customRender: "type_plafon" },
      },
      {
        title: "Plafon Status",
        key: "status_keuangan",
        align: "center",
        // fixed: "right",
        scopedSlots: { customRender: "status_keuangan" },
      },
    ];

    return {
      create_modal: false,
      columns,
      // columns_need_process,
      moment,
      loading: {
        table: false,
        list: false,
      },
      data_table: [],
      data_directorate: [],
      data_status: [
        "Delivered",
        "Waiting",
        "On Process",
        "Approved",
        "Rejected",
        "Revised",
      ],
      searchTemp: null,
      filter: {
        search: null,
        directorate: undefined,
        status: undefined,
        start_date: null,
        end_date: null,
      },
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
      },
      pagination_np: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
      },
      files: [],
      modal_file: false,
      state_file: {},
      dates: null,
      tab_active_key: "1",
      data_table_need_process: [],
    };
  },

  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatusLapUMPD",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    isMonitoringPage() {
      return this.$route.meta.is_monitoring
    }
  },

  mounted() {
    if (this.isMonitoringPage) {
      this.tab_active_key = '2'
    } else {
      this.refetchData();
    }

    this.getDirectorate();
  },

  methods: {
    showModalCreate() {
      this.create_modal = true;
    },

    async fetchDataList() {
      try {
        this.loading.table = true;
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + "monitoring/pp_inventory",
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          params: { ...this.pagination, ...this.filter, id: localStorage.getItem("nvky") }
        });
        this.data_table = response.data.data;
        this.pagination.total = response.data.pagination.total_data;
        this.loading.table = false;
      } catch (error) {
        console.log(error);
        this.loading.table = false;
      }
    },

    refetchData() {
      this.fetchDataList();
    },

    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.refetchData();
    },

    handleTableChangeNp(pagination) {
      this.pagination_np.current = pagination.current;
      this.pagination_np.pageSize = pagination.pageSize;
      this.refetchData();
    },

    stateColor(state) {
      if (state == "0" || state == "On Process") return "orange";
      else if (state == "1" || state == "Verified" || state == "Approved")
        return "green";
      else if (state == "2" || state == "Rejected") return "red";
      else if (state == "Revised") return "orange";
      else if (state == "Delivered") return "blue";
    },

    stateColorAp(state) {
      if (state == "Has Been Allocated") return "green";
      else return "RED";
    },

    stateActive(state) {
      if (state == "0") return "DRAFT";
      else if (state == "1") return "ACTIVE";
      else if (state == "2") return "NON ACTIVE";
    },

    async getDirectorate() {
      try {
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + `kewajiban/directorate`,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        });
        this.data_directorate = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },

    onSearch(search) {
      this.filter.search = search;
    },

    resetFilter() {
      this.pagination.current = 1;
      this.pagination_np.current = 1;
      this.searchTemp = null;
      this.filter.search = null;
      this.filter.directorate = undefined;
      this.filter.status = undefined;
      this.filter.start_date = null;
      this.filter.end_date = null;
    },

    onChangeDateFilter(val) {
      if (val.length > 0) {
        this.filter.start_date = this.moment(val[0]).format("YYYY-MM-DD");
        this.filter.end_date = this.moment(val[1]).format("YYYY-MM-DD");
      } else {
        this.filter.start_date = null;
        this.filter.end_date = null;
      }
    },
    toManifest(item){
      this.gotoManifestTrans(this, item, "_blank")
    },

    navigateTo(name, id = "", payload = null) {
      if (name == "create") {
        this.$store.dispatch("setSelectedReminder", null);
        this.$router.push({ name: "kewajiban_create" });
      } else if (name == "manifest") {
        let page_nm = 'kewajiban_manifest';
        if (this.isMonitoringPage) {
          if (this.$route.path.includes('/financialControl/')) {
            page_nm = 'kewajiban_manifestFC';
          } else if (this.$route.path.includes('/akuntansiKeuangan/')) {
            page_nm = 'kewajiban_manifestAcc';
          } else if (this.$route.path.includes('/keuangan/')) {
            page_nm = 'kewajiban_manifestKeu';
          } else if (this.$route.path.includes('/pimpro/')) {
            page_nm = 'kewajiban_manifestPimpro';
          } else if (this.$route.path.includes('/atasanLangsung/')) {
            page_nm = 'kewajiban_manifestAL';
          }
        }
        this.$router.push({
          name: page_nm,
          params: {
            id: id,
          },
        });
      } else if (name == "create_reminder") {
        this.$store.dispatch("setSelectedReminder", payload);
        this.$router.push({ name: "kewajiban_create" });
      } else if (name == "edit") {
        this.$router.push({
          name: "kewajiban_edit",
          params: {
            id: id,
          },
        });
      } else if (['rekap_cc_ticket', 'rekap_klaim_kesehatan', 'rekap_lkpd'].includes(name)) {
        let pgname = 'rekapKlaimTiketManifest';
        if (name == "rekap_klaim_kesehatan") {
          pgname = 'rekapKlaimKesehatanManifest-hrd';
        } else if (name == "rekap_lkpd") {
          pgname = 'rekapLKPDManifest';
        }
        const route = this.$router.resolve({
          name: pgname,
          params: {
            id: id,
          },
        });
        window.open(route.href, "_blank");
      }
    },
  },

  watch: {
    filter: {
      handler() {
        this.pagination.current = 1;
        this.pagination_np.current = 1;
        this.refetchData();
      },
      deep: true
    },
    tab_active_key() {
      this.pagination.current = 1;
      this.pagination_np.current = 1;
      this.refetchData();
    }
  },
};
</script>

<style lang="less">
.c_primary {
  .ant-card-head-title {
    margin-right: 0px !important;
  }

  .cmain-title {
    max-width: 50%;
    text-wrap: auto;
    word-break: normal;
  }

  .cbtn-create {
    i {
      color: #fff;
    }

    path {
      color: #fff;
    }

    span {
      color: #fff;
    }
  }

  .hdr_plfn {
    .ant-table-title {
      padding-bottom: 0px;
    }
  }

  .option_plfn {
    td {
      padding: 0px;
    }
  }

  .hdr_plfn_selection {
    padding: 16px;
    cursor: pointer;
  }

  .hdr_plfn_selection.isfocused {
    background-color: fade(@color-secondary, 5%);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25), 0 2px 8px rgba(0, 0, 0, 0.25),
      inset 0px 0px 0px 1px rgba(255, 255, 255, 0.1);
    border-left-style: solid;
    border-left-color: @color-secondary;
  }

  .row-ecv {
    .ant-input-number {
      justify-content: flex-end;
    }

    .ant-input-number-input {
      text-align: right;
      display: block;
    }
  }

  .row_h {
    margin-right: 11px;
  }

  .ngabango {
    background-color: fade(@color-primary, 35%);
  }
}

.cAnnualfromcreate {
  .ant-input-number-input {
    text-align: right;
    padding-right: 25px;
  }
}

.plafonformtables {

  // .ant-table-row {
  .ant-table-thead {
    background: #c1c1c1;
    font-weight: bolder;
  }

  tr:first-child {
    td:hover {
      background: #00ca8e;
    }
  }

  td:nth-child(4) {
    background: #c1c1c1;
  }

  .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY)>td,
  .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY)>td,
  .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY)>td,
  .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY)>td {
    background: none;
  }

  .ant-table-thead>tr.cSUMMARY.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
  .ant-table-tbody>tr.cSUMMARY.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
  .ant-table-thead>tr.cSUMMARY:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
  .ant-table-tbody>tr.cSUMMARY:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #c1c1c1;
  }

  // }
}

.overvalueRow {
  background-color: fade(@color-primary, 35%);
}

.custom-card .ant-card-body {
  padding: 0px !important;
}

.custom-table .ant-table {
  border: none !important;
}

.custom-table .ant-table-container {
  border-inline-start: none !important;
  border-top: none !important;
}

.custom-table .ant-table-bordered>.ant-table-container {
  border: none !important;
}

.single-parent {
  text-transform: uppercase;
  font-weight: bold;
}

.summary-row td {
  background: #f3e8e8 !important;
  font-weight: bold;
}

.chart-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-big-text .ant-progress-text {
  font-size: 22px !important;
  font-weight: bold;
}

.footer-card {
  margin-top: 10px;
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.link-hover {
  cursor: pointer;
  color: inherit;
  text-decoration: none;
  transition: color 0.2s ease;
}

.link-hover:hover {
  color: #1677ff;
  text-decoration: underline;
}
</style>
